import {analyticsLogEvent} from '../api'

const eventName = 'contactUs'

interface Parameters {
    action: 'submit_ok' | 'submit_fail'
    /** Reason of the request (e.g. 'size', 'storesavailability'); prefixed with 'product - ' in the label. */
    reason?: string
    /** Product ID (SKU) the contact request refers to → dimension23. */
    productId?: string
    /** '[COUNTRY - BOUTIQUE]' → dimension24, only for the find-in-boutique flow. */
    countryBoutique?: string
}

/**
 * Tracks a Contact Us form submission from the PDP.
 *
 * SFRA spec §6.11:
 * ```
 * {
 *   event: 'contactUs',
 *   eventCategory: 'Contact Us - PDP',
 *   eventAction: 'submit_ok' | 'submit_fail',
 *   eventLabel: 'product - [REASON]',
 *   dimension23: '[PRODUCT_ID]',
 *   dimension24: '[COUNTRY - BOUTIQUE]'   // only for findinboutique
 * }
 * ```
 *
 * @param {Parameters} params - Object containing the event parameters.
 * @param {'submit_ok' | 'submit_fail'} params.action - Submission outcome.
 * @param {string} [params.reason] - Selected request reason.
 * @param {string} [params.productId] - Product ID (dimension23).
 * @param {string} [params.countryBoutique] - Country - boutique (dimension24), find-in-boutique only.
 */
export function analyticsEventContactUs({action, reason, productId, countryBoutique}: Parameters): void {
    const eventDetails = {
        eventCategory: 'Contact Us - PDP',
        eventAction: action,
        eventLabel: `product - ${reason ?? ''}`,
        dimension23: productId ?? '',
        ...(countryBoutique ? {dimension24: countryBoutique} : {}),
    }

    analyticsLogEvent(eventName, eventDetails)
}
